const READ_PLATFORM_PATH = process.env.READ_PLATFORM_PATH
const JGSSO_WEB_URL = process.env.JGSSO_WEB_URL
const BANNER_URL = process.env.BANNER_URL
const constant = {
}
// 公用的appCode
constant.COMMON_APPCODE = 'cbzx'
constant.read_web_url = READ_PLATFORM_PATH
constant.JGSSO_WEB_URL = JGSSO_WEB_URL
constant.BANNER_URL= BANNER_URL

// 品类CODE
constant.pl_ts = 'ts' // 图书
constant.pl_ptts = 'ptts' // 普通图书
constant.pl_gf = 'bz' // 规范
constant.pl_al = 'al' // 案例
constant.pl_tuku = 'tuku' // 图库ptts
constant.pl_qk = 'qk' // 期刊
constant.pl_ksjc = 'ksjc' // 考试教材
constant.pl_sp = 'sp' // 视频
constant.pl_kejian = 'kj' // 课件
constant.pl_st = 'st' // 试题
constant.pl_sj = 'sj' // 试卷
constant.pl_xt = 'xt' // 习题
constant.pl_tk = 'tk' // 题库
constant.pl_kec = 'ck' // 课程
constant.pl_zlj = 'zlj' // 室内设计 室内设计资料集（第二版）
constant.pl_hpjzxbsjtk = 'tuku' // 室内设计 海派建筑细部设计图库
constant.pl_wz = 'wz' // 文章
constant.pl_lxcbw = 'lxcbw' // 连续出版物

// 模块CODE
constant.zgtcjzyzjyywh = 'zgtcjzyzjyywh' // 中国传统建筑营造技艺与文化
constant.dfjzyzjy = 'dfjzyzjy' // 中国传统建筑营造技艺与文化--地方建筑营造技艺--模块查询
constant.yzjy_62 = 'yzjy_62' // 中国传统建筑营造技艺与文化--地方建筑营造技艺--62项非遗技艺
constant.yzjy_zyk = 'yzjy_zyk' // 中国传统建筑营造技艺与文化--地方建筑营造技艺--中国传统建筑营造技艺多媒体资源库
constant.szgb = 'szgb' // 中国传统建筑营造技艺与文化--神州瑰宝--模块查询
constant.szcc = 'szcc' // 中国传统建筑营造技艺与文化--数字长城--模块查询

constant.jzsjzl = 'jzsjzl' // 建筑设计资料
constant.jzsjzljdeb = 'jzsjzlj' // 建筑设计资料--建筑设计资料集
constant.jzsjzl_ts = 'JZSJZL-ts' // 建筑设计资料--建筑设计资料集--图书
constant.jzsjzl_qk = 'JZSJZL-qk' // 建筑设计资料--建筑设计资料集--期刊
constant.jzsjzl_bzgf = 'JZSJZL-bzgf' // 建筑设计资料--建筑设计资料集--标准规范
constant.jzsjzl_al = 'JZSJZL-al' // 建筑设计资料--建筑设计资料集--案例
constant.jzsjzl_spk = 'JZSJZL-spk' // 建筑设计资料--建筑设计资料集--视频课
constant.jzsjzlj_fcj = 'jzsjzlj_fcj' // 建筑设计资料--建筑设计资料集--分册集
constant.jzsjzlj_cgf = 'jzsjzlj_cgf' // 建筑设计资料--建筑设计资料集--查规范
constant.jzsjzlj_zsfw = 'jzsjzlj_zsfw' // 建筑设计资料--建筑设计资料集--知识服务
constant.JZSJZL_ts = 'JZSJZL-ts' // 建筑设计资料--建筑设计资料集--图书
constant.jzsjzlj_yspkc = 'jzsjzlj_yspkc' // 建筑设计资料--建筑设计资料集--查规范--音视频课程
constant.jzsjzlj_kspx = 'jzsjzlj_kspx' // 建筑设计资料--建筑设计资料集--查规范--考试培训


constant.jzszyzgks = 'jzszyzgks' // 建筑师执业资格考试
constant.yjzcjzs = 'yjzcjzs' // 建筑师执业资格考试--一级
constant.yjzcjzs_tk = 'tk' // 建筑师执业资格考试--一级
constant.ejzcjzs = 'ejzcjzs' // 建筑师执业资格考试--二级
constant.ejzcjzs_tk = 'ejtk' // 建筑师执业资格考试--二级
constant.tk = 'tk' // 建筑师执业资格考试 - 题库
// constant.journal = 'journal' // 建筑师
// constant.tk = 'tk' // 建筑师执业资格考试 - 题库
// constant.tk = 'tk' // 建筑师执业资格考试 - 题库
constant.jzsj_qk = 'jzszyzgks-qk' // 期刊 
constant.jzsj_zl = 'jzszyzgks-xs-zl' // 专栏
constant.jzsj_rw = 'jzszyzgks-xs-rw' // 人物
constant.jzsj_fx = 'jzszyzgks-xs-fx' // 方向
constant.jzsj_xs = 'jzszyzgks-xs' // 学术
constant.jzszyzgks_js = 'jzszyzgks-js' // 竞赛
constant.jzs_js_jshg = 'jzs_js_jshg' // 竞赛回顾
constant.jzszyzgks_lxwm = "'zszyzgks-lxwm" //联系我们


constant.bim = 'bim' // BIM
constant.gjk = 'gjk' // BIM--构件库
constant.mxk = 'mxk' // BIM--模型库
constant.bim_ksjc = 'BIM-ksjc' // BIM--考试教材
constant.bim_kj = 'BIM-kj' // BIM--课件
constant.bim_gcal = 'BIM-gcal' // BIM--工程案例
constant.bim_kc = 'bim_pxkc' // BIM--课程
constant.bim_ts = 'bim_ts' // BIM--图书
constant.bim_wdhd = 'BIM-wdhd' // BIM--问答互动

constant.yljg = 'yljg' // 园林景观
constant.fjylzlj = 'fjylzlj' // 园林景观 风景园林资料集--模块查询
constant.jgsj = 'jgsj' // 园林景观 景观设计--模块查询
constant.alsc = 'alsc' // 园林景观 案例素材
constant.yljg_ts = 'YLJG-TS' // 园林景观 图书
constant.yljg_tk = 'YLJG-TK' // 园林景观 图库
constant.yljg_spk = 'YLJG-SPK' // 园林景观 视频课
constant.yljg_qk = 'YLJG-QK' // 园林景观 期刊
constant.yljg_bzgf = 'YLJG-BZGF' // 园林景观 标准规范

constant.jzsb = 'jzsb' // 建筑设备
constant.jzsb_ts = 'jzsb_ts' // 建筑设备-图书
constant.jps_sc = 'jps-sc' // 建筑设备-给排水-手册
constant.jzsb_gf = 'jzsb_gf' // 建筑设备-规范
constant.nt_sc = 'nt-sc' // 建筑设备-暖通-手册
constant.jzsb_gcal = 'jzsb_gcal' // 建筑设备-案例
constant.dq_sc = 'dq-sc' // 建筑设备-电气-手册
constant.journal = "journal" //学术页面


constant.snsj = 'SNSJ' // 室内设计
constant.hpjzxbsjtk = 'hpjzxbsjtk' // 室内设计  海派建筑细部设计图库--模块查询
constant.sjsjzljdeb = 'snsjzlj' // 室内设计 室内设计资料集（第二版）
constant.zljzzzy = 'zljzzzy' // 室内设计 室内设计资料集（第二版） 资料集增值资源
constant.dspd = 'dspd' // 室内设计 室内设计资料集（第二版） 大师频道
constant.snsj_qnhm = 'snsj-qnhm' // 室内设计 千年回眸
constant.snsj_qk = 'SNSJ-qk' // 室内设计 期刊
constant.snsj_al = 'snsj-al' //室内设计 -- 案例


constant.jzjn = 'jzjn' // 建筑节能
constant.jzjn_ts = 'jzjn-ts' // 建筑节能 -- 图书
constant.jzjn_ts_jnzc = 'jzjn-ts-jnzc' // 建筑节能 -- 图书
constant.jzjn_ts_jnbg = 'jzjn-ts-jnbg' // 建筑节能 -- 图书
constant.jzjn_ts_jnsj = 'jzjn-ts-jnsj' // 建筑节能 -- 图书
constant.jzjn_ts_jnjs = 'jzjn-ts-jnjs' // 建筑节能 -- 图书
constant.jzjn_gf = 'jzjn-gf' // 建筑节能 -- 规范
constant.jzjn_jnzc = 'jzjn-jnzc' // 建筑节能--节能政策
constant.jnzc_bg = 'jnzc-bg' // 建筑节能--节能政策--报告
constant.jzjn_jnln = 'jzjn-jnln' // 建筑节能--节能理念
constant.jnln_bg = 'jnln-bg' // 建筑节能--节能理念--报告
constant.jzjn_jnsj = 'jzjn-jnsj' // 建筑节能--节能设计
constant.jnsj_bg = 'jnsj-bg' // 建筑节能--节能设计--报告
constant.jzjn_jnjs = 'jzjn-jnjs' // 建筑节能--节能技术
constant.jnjs_bg = 'jnjs-bg' // 建筑节能--节能技术--报告


constant.categoryCode = [
  {id: '01', code: 'ts', text: '图书'},
  {id: '02', code: 'ptts', text: '普通图书'},
  {id: '03', code: 'nj', text: '年鉴'},
  {id: '04', code: 'gjs', text: '条目型工具书'},
  {id: '05', code: 'ksjc', text: '考试教材'},
  {id: '09', code: 'tq', text: '其他图书'},
  {id: '10', code: 'djc', text: '单卷册'},
  {id: '11', code: 'dqqk', text: '单期期刊'},
  {id: '12', code: 'dqlwj', text: '单期论文集'},
  {id: '19', code: 'qtdjc', text: '其他单卷册'},
  {id: '21', code: 'bz', text: '标准'},
  {id: '22', code: 'bzhi', text: '报纸'},
  {id: '30', code: 'ck', text: '课程'},
  {id: '31', code: 'sj', text: '试卷'},
  {id: '32', code: 'xt', text: '习题'},
  {id: '33', code: 'kj', text: '课件'},
  {id: '39', code: 'tqkc', text: '其他课程'},
  {id: '41', code: 'tp', text: '图片'},
  {id: '42', code: 'gs', text: '公式'},
  {id: '43', code: 'dzbg', text: '电子表格'},
  {id: '50', code: 'ysp', text: '音视频'},
  {id: '51', code: 'yp', text: '音频'},
  {id: '52', code: 'sp', text: '视频'},
  {id: '53', code: 'dh', text: '动画'},
  {id: '59', code: 'qtysp', text: '其他音视频'},
  {id: '60', code: 'al', text: '案例'},
  {id: '61', code: 'zlj', text: '资料集'},
  {id: '99', code: 'qt', text: '其他类型'}
]

export default constant



// WEBPACK FOOTER //
// ./src/api/constant.js